import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";

const PAGE_TYPE = "StoreLocator";

const QUERY_STORE_LOCATOR = gql`
  query storeLocator($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}: storeLocator(uid: $uid, lang: $lang) {
      title
      campaign_sale_link {
        ... on Campaign_sale1 {
          _meta {
            uid
          }
        }
      }
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
    }
  }
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
`;

export { PAGE_TYPE, QUERY_STORE_LOCATOR };
